import { Box, TableCell } from '@mui/material';
import { CPCButton } from './CPCButton';
import type { CPCOfferProps } from './types';

type CPCTableCellProps = CPCOfferProps & {
  modalVariant?: 'cpc' | 'wealthfront';
  shouldApplyStylingUpdates?: boolean;
};

export function CPCTableCell({
  cta,
  analyticsPayload,
  displayName,
  image,
  modalVariant = 'cpc',
  shouldApplyStylingUpdates,
}: CPCTableCellProps) {
  return (
    <TableCell
      sx={{
        width: 159,
        paddingY: 3,
        paddingTop: `var(--cell-padding-top)`,
        paddingX: 2,
        display: { xs: 'none', md: 'table-cell' },
        ...(shouldApplyStylingUpdates && { textAlign: 'center' }),
      }}
    >
      <Box
        data-testid="cpc-table-cell"
        sx={{
          display: { xs: 'none', md: 'block' },
          width: '159px',
          ...(shouldApplyStylingUpdates && { marginX: 'auto' }),
        }}
      >
        <CPCButton
          modalVariant={modalVariant}
          buttonAnalytics={{
            actionName: 'summary_table_product_modal_cta_clicked',
            impressionSection: 'summary_table_product_modal_cta',
          }}
          cta={cta}
          analyticsPayload={analyticsPayload}
          displayName={displayName}
          image={image}
        />
      </Box>
    </TableCell>
  );
}
